const environment =
  process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;

const secrets = {
  api: {
    baseUri: process.env.REACT_APP_BASE_URI
  },
  pti: {
    //token: 'u8yoQEN8qaPWN04Uuc0sXxiuxnz3tXHBE8ilM3FbTmAqKzyv',
    token: 'sLCLVyKPjkDewoeYuUJqDmR6x7uvth3X',
    issueUrl: 'https://preflighttech.com/api/1/issues',
    ticketUrl: (
      process.env.REACT_APP_PTI_TICKET_URL ||
      'https://preflighttech.com/api/1/trouble_tickets'
    ),
  },
  app: {
    name: 'el-auction',
    doubleEntry: true,
  }
};

export default secrets;
